import { Alert, Breadcrumbs, Checkbox, FormControlLabel, Grid, IconButton, Link, Typography } from "@mui/material"
import HomeIcon from '@mui/icons-material/Home';
import { useTranslation } from "react-i18next";
import { LoadButton } from "../components/loadButton";
import { useTheme } from "@emotion/react";
import { useHistory } from "react-router";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import React, { useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { ConnectedApp, CreateDossierDto, FileDto, IDossierApiClient } from "../clients/dossierApiClient";
import { useImmer } from "use-immer";
import { useInjection } from "../di/ioc-provider";
import { TYPES } from "../di/types";
import { convertArrayBufferToBase64 } from "../helpers";
import { Close, FilePresent } from "@mui/icons-material";
import Loader from "../components/Loader";
import { CountryPicker } from "../components/CountryPicker";
import { UserPicker } from "../components/userPicker";
import { TeamleaderLink } from "../components/teamleaderLink";
import { SearchCompaniesViaTeamleader } from "../components/searchViaTeamleader";
import GeneralDialog from "../components/generalDialog";
import { SearchInvoicesViaTeamleader } from "../components/searchInvoicesViaTeamleader";
import TeamleaderLogo from "../assets/TeamleaderIcon.jpg";
import OctopusLogo from "../assets/ocotpus.jpg";
import { OctopusLink } from "../components/octopusLink";
import { SearchCompaniesViaOctopus } from "../components/searchCompaniesViaOctopus";
import { SearchInvoicesViaOctopus } from "../components/searchInvoicesViaOctopus";
import { UserAddressPicker } from "../components/userAddressPicker";
import { ExactOnlineLink } from "../components/ExactonlineLink";

export const CreateNewDossierPage = () => {
    const theme = useTheme();
    const [t] = useTranslation("common");
    const history = useHistory();
    const formRef = useRef(null);
    const [step, setStep] = React.useState(1);
    const [saving, setSaving] = React.useState(false);
    const _dossierApiClient = useInjection<IDossierApiClient>(TYPES.IDossierClient);
    const [error, setError] = React.useState(false);
    const [succeeded, setSucceeded] = React.useState(false);
    const [autoFillLoading, setAutoFillLoading] = React.useState(false);
    const [openFileErrorDialog, setOpenFileErrorDialog] = React.useState(false);
    const [formModel, setFormModel] = useImmer<CreateDossierDto>({
        debEmail: "",
        debAddress: "",
        debCity: "",
        debHouseNr: "",
        debName: "",
        debPostalcode: "",
        debVat: "",
        files: [],
        invoices: [],
        name: "",
        betwist: false,
        totalValue: 0,
        viesServiceRaw: "",
        rappels: [],
        debCountry: "BE",
        foreignInvoices: [],
        remarks: ""
    });

    const readFileDrop = (acceptedFiles, addToFormModel: (dto: FileDto) => void, index: number) => {
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
            var filesize = reader.result;

            if ((filesize as any).maxByteLength > 5000000) {
                setOpenFileErrorDialog(true);
            } else {
                const binaryStr = reader.result
                var base64 = convertArrayBufferToBase64(binaryStr as ArrayBuffer);
                addToFormModel({ name: file.name, fileBase64: base64 });
                if (index != acceptedFiles.length - 1) {
                    readFileDrop(acceptedFiles, addToFormModel, index + 1);
                }
            }


        }
        var file = acceptedFiles[index];
        reader.readAsArrayBuffer(file);

    }
    const onDrop = useCallback(acceptedFiles => {
        readFileDrop(acceptedFiles, (file) => {
            setFormModel((draft) => {

                draft.invoices.push(file)
            })
        }, 0)

    }, [])
    const onDropRappels = useCallback(acceptedFiles => {
        readFileDrop(acceptedFiles, (file) => {
            setFormModel((draft) => {

                draft.rappels.push(file)
            })
        }, 0)

    }, [])
    const onDropMessages = useCallback(acceptedFiles => {
        readFileDrop(acceptedFiles, (file) => {
            setFormModel((draft) => {

                draft.files.push(file)
            })
        }, 0)

    }, [])
    const saveValidateDebInfo = () => {
        if (formRef != null && formRef.current != null) {
            var testForm = formRef.current as any;
            testForm
                .isFormValid()
                .then((result: boolean) => {
                    if (result) {
                        setStep(2);
                    }
                })
                .catch((err: any) => { });
        }
    };

    const createDossier = () => {
        setSaving(true);
        _dossierApiClient.createDossier(formModel).takeAtLeast(1000).then((res) => {
            setSucceeded(true);
            setTimeout(() => {
                history.push("/");
            }, 1500)
        }).catch((err) => {
            setError(true);
        }).finally(() => {
            setSaving(false);
        })
    }
    const autofill = () => {
        setAutoFillLoading(true);
        _dossierApiClient.getCompanyAutofill(formModel.debCountry, formModel.debVat).then((res) => {
            if (res.data == null) return;
            if (res.data?.name != null || res.data?.name != '') {
                setFormModel((draft) => {
                    draft.debAddress = res.data.address;
                    draft.debCity = res.data.city;
                    draft.debHouseNr = res.data.hnr;
                    draft.debPostalcode = res.data.postalCode;
                    draft.debName = res.data.name;

                })
            }
        }).finally(() => {
            setAutoFillLoading(false);
        })

    }
    const tryParseAddressFromTl = (address: string) => {
        try {
            var split = address.split(" ");
            var temp = "";
            if (split.length <= 1) return address;

            for (var i = 0; i < split.length - 1; i++) {
                temp += split[i];
            }
            return temp;
        } catch {

        }
        return address;
    }
    const tryParseHouseNrFromTl = (address: string) => {
        try {
            var split = address.split(" ");
            return split[split.length - 1];
        } catch {

        }
        return "";
    }
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
    const { getRootProps: getRootPropsAttachments, getInputProps: getInputPropsAttachments, isDragActive: isDragActiveAttachments } = useDropzone({ onDrop: onDropRappels })
    const { getRootProps: getRootPropsMessageAttchements, getInputProps: getInputPropsMessageAttchements, isDragActive: isDragMessageAttchements } = useDropzone({ onDrop: onDropMessages })
    return <>
        <GeneralDialog open={openFileErrorDialog} onClose={() => { setOpenFileErrorDialog(false) }}>
            <Alert severity="error">{<Typography color={"#0951a4"}> {t("general.errorFileMaxLimit")}</Typography>}</Alert>
        </GeneralDialog>
        <Grid container justifyContent={"space-between"}>
            <Grid item xs={12}>
                <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                    <Link
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                        color="inherit"
                        onClick={() => { history.goBack() }}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        {t("route.dossiers")}
                    </Link>
                    <Link
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                        color="inherit"
                        onClick={() => { }}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        {t("route.createDossier")}
                    </Link>
                </Breadcrumbs>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h1" color={(theme as any).background.header}>{t("route.createDossier")}</Typography>
            </Grid>
        </Grid>
        <Grid container>
            <Grid item md={4} xs={12}>
                <Timeline position="right">
                    <TimelineItem>
                        <TimelineSeparator>
                            <TimelineDot color={step <= 1 ? 'grey' : "success"} />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>{t("createDossier.step1")}</TimelineContent>
                    </TimelineItem>
                    <TimelineItem>
                        <TimelineSeparator>
                            <TimelineDot color={step <= 2 ? 'grey' : "success"} />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>{t("createDossier.step2")}</TimelineContent>
                    </TimelineItem>
                    <TimelineItem>
                        <TimelineSeparator>
                            <TimelineDot color={step <= 3 ? 'grey' : "success"} />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>{t("createDossier.step3")}</TimelineContent>
                    </TimelineItem>
                    {formModel.betwist ? <>  <TimelineItem>
                        <TimelineSeparator>
                            <TimelineDot color={step <= 4 ? 'grey' : "success"} />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>{t("createDossier.step4")}</TimelineContent>
                    </TimelineItem></> : <></>}

                    <TimelineItem>
                        <TimelineSeparator>
                            <TimelineDot color={step <= 4 ? 'grey' : "success"} />
                        </TimelineSeparator>
                        <TimelineContent>{t("createDossier.step5")}</TimelineContent>
                    </TimelineItem>
                </Timeline>
            </Grid>
            {saving ? <><Grid item md={8} xs={12}><p><Loader /> {t("createDossier.createDossierSaving")}</p></Grid></> :
                <><Grid item md={8} xs={12}>
                    {error ? <><Alert severity="error">{t("createDossier.errorCreatingDossier")}</Alert></> : <></>}
                    {succeeded ? <><Alert severity="success">{t("createDossier.createDossierSuccess")}</Alert></> : <></>}
                    {step == 1 ? <>
                        <Typography variant="h2">{t("createDossier.step1Desc")}</Typography>
                        <TeamleaderLink>

                            <SearchCompaniesViaTeamleader onSelected={(comp) => {
                                setFormModel((draft) => {
                                    draft.debName = comp.name;
                                    draft.debVat = comp.vat;
                                    draft.debEmail = comp.email;
                                    draft.debAddress = tryParseAddressFromTl(comp.address);
                                    draft.debCity = comp.city;
                                    draft.debPostalcode = comp.postalcode;
                                    draft.debHouseNr = comp.houseNr;
                                    draft.debCountry = comp.country;
                                    draft.debForeignId = comp.id;
                                    draft.debHouseNr = tryParseHouseNrFromTl(comp.address);
                                    draft.debAppId = ConnectedApp.Teamleader;
                                })
                            }} />
                        </TeamleaderLink>
                        <OctopusLink>
                            <SearchCompaniesViaOctopus onSelected={(comp) => {
                                setFormModel((draft) => {
                                    draft.debName = comp.name;
                                    draft.debVat = comp.vat;
                                    draft.debEmail = comp.email;
                                    draft.debAddress = tryParseAddressFromTl(comp.address);
                                    draft.debCity = comp.city;
                                    draft.debPostalcode = comp.postalcode;
                                    draft.debHouseNr = comp.houseNr;
                                    draft.debCountry = comp.country;
                                    draft.debForeignId = comp.id;
                                    draft.debHouseNr = tryParseHouseNrFromTl(comp.address);
                                    draft.debAppId = ConnectedApp.Octopus;
                                })
                            }} />
                        </OctopusLink>
                        {/* <ExactOnlineLink >

                        </ExactOnlineLink> */}
                        <UserPicker onUserSelected={(id) => { setFormModel((draft) => { draft.userId = id }) }} />
                        <UserAddressPicker onUserAddressSelected={(id) => { setFormModel((draft) => { draft.addressId = id }) }} />
                        <ValidatorForm style={{ width: "100%" }} ref={formRef} onSubmit={() => { }}>
                            <TextValidator
                                InputLabelProps={{ shrink: formModel.debName != "" }}
                                disabled={saving}
                                margin="normal"

                                fullWidth
                                label={t("general.custName")}
                                name="email"
                                value={formModel.debName}
                                validators={["required"]}
                                errorMessages={[t("validation.required")]}
                                onChange={(ev) => {
                                    setFormModel((draft) => {
                                        draft.debName = ev.target.value;
                                    })
                                }}
                            />

                            <TextValidator
                                InputLabelProps={{ shrink: formModel.debEmail != "" }}
                                disabled={saving}
                                margin="normal"
                                fullWidth
                                label={t("general.custEmail")}
                                name="email"
                                value={formModel.debEmail}
                                validators={["required"]}
                                errorMessages={[t("validation.required")]}
                                onChange={(ev) => {
                                    setFormModel((draft) => {
                                        draft.debEmail = ev.target.value;
                                    })
                                }}
                            />
                            <Grid container spacing={1}>
                                <Grid item xs={4}>
                                    <CountryPicker defaultCountry={"BE"} label={""} onSelected={(dto) => {
                                        setFormModel((draft) => { draft.debCountry = dto.code })
                                    }} />
                                </Grid>
                                <Grid item xs={8}>
                                    <TextValidator
                                        InputLabelProps={{ shrink: formModel.debVat != "" }}
                                        disabled={saving}
                                        margin="normal"
                                        fullWidth
                                        label={t("general.custVat")}
                                        name="email"
                                        value={formModel.debVat}
                                        onChange={(ev) => {
                                            setFormModel((draft) => {
                                                draft.debVat = ev.target.value;
                                            })
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <LoadButton
                                color={"secondary"}
                                style={{ width: "100%", marginTop: "14px" }}
                                isLoading={autoFillLoading}
                                variant="contained"
                                buttonText={t("createDossier.autoFill")}
                                onClick={autofill}>

                            </LoadButton>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={10}>
                                    <TextValidator
                                        InputLabelProps={{ shrink: formModel.debAddress != "" }}
                                        disabled={saving}
                                        margin="normal"
                                        fullWidth
                                        label={t("general.custStreet")}
                                        name="email"
                                        value={formModel.debAddress}
                                        validators={["required"]}
                                        errorMessages={[t("validation.required")]}
                                        onChange={(ev) => {
                                            setFormModel((draft) => {
                                                draft.debAddress = ev.target.value;
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextValidator

                                        InputLabelProps={{ shrink: formModel.debHouseNr != "" }}
                                        disabled={saving}
                                        margin="normal"
                                        fullWidth
                                        label={t("general.custHouseNr")}
                                        name="email"
                                        value={formModel.debHouseNr}
                                        validators={["required"]}
                                        errorMessages={[t("validation.required")]}
                                        onChange={(ev) => {
                                            setFormModel((draft) => {
                                                draft.debHouseNr = ev.target.value;
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextValidator
                                        InputLabelProps={{ shrink: formModel.debPostalcode != "" }}
                                        disabled={saving}
                                        margin="normal"
                                        fullWidth
                                        label={t("general.custPostal")}
                                        name="email"
                                        value={formModel.debPostalcode}
                                        validators={["required"]}
                                        errorMessages={[t("validation.required")]}
                                        onChange={(ev) => {
                                            setFormModel((draft) => {
                                                draft.debPostalcode = ev.target.value;
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextValidator
                                        InputLabelProps={{ shrink: formModel.debCity != "" }}
                                        disabled={saving}
                                        margin="normal"

                                        fullWidth
                                        label={t("general.custCity")}
                                        name="email"
                                        value={formModel.debCity}
                                        validators={["required"]}
                                        errorMessages={[t("validation.required")]}
                                        onChange={(ev) => {
                                            setFormModel((draft) => {
                                                draft.debCity = ev.target.value;
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextValidator
                                        InputLabelProps={{ shrink: formModel.totalValue != -1 }}
                                        disabled={saving}
                                        margin="normal"
                                        type="number"
                                        fullWidth
                                        label={t("general.totalValue")}
                                        name="email"
                                        value={formModel.totalValue}
                                        validators={["required"]}
                                        errorMessages={[t("validation.required")]}
                                        onChange={(ev) => {
                                            setFormModel((draft) => {
                                                draft.totalValue = ev.target.value;
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextValidator
                                        InputLabelProps={{ shrink: formModel.remarks != "" }}
                                        multiline
                                        rows={4}
                                        disabled={saving}
                                        margin="normal"
                                        type="text"
                                        fullWidth
                                        label={t("general.remarks")}
                                        name="remarks"
                                        value={formModel.remarks}
                                        validators={[]}
                                        errorMessages={[]}
                                        onChange={(ev) => {
                                            setFormModel((draft) => {
                                                draft.remarks = ev.target.value;
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControlLabel control={<Checkbox value={formModel.betwist} onChange={(ev) => {
                                        setFormModel((draft) => {
                                            draft.betwist = ev.target.checked
                                        })
                                    }}></Checkbox>} label={t("general.betwist")} />

                                </Grid>

                                <Grid container justifyContent={"flex-end"}>
                                    <Grid item>
                                        <LoadButton
                                            color={"primary"}
                                            style={{ width: "100%", marginTop: "14px" }}
                                            isLoading={saving}
                                            type="submit"
                                            variant="contained"
                                            buttonText={t("createDossier.next")}
                                            onClick={saveValidateDebInfo}>

                                        </LoadButton>
                                    </Grid>

                                </Grid>

                            </Grid>
                        </ValidatorForm></> : <></>}
                    {step == 2 ? <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="h2">{t("createDossier.step2Desc")}</Typography>
                            </Grid>
                            {formModel.debAppId == ConnectedApp.Teamleader ? <>
                                <Grid item xs={4}>
                                    <TeamleaderLink>
                                        <SearchInvoicesViaTeamleader onSelectInvoices={(invoices) => {
                                            setFormModel((draft) => {
                                                var fi = invoices.map((el) => { return { id: el.id, invoiceNumber: el.invoiceNumber, app: ConnectedApp.Teamleader } });
                                                for (var i = 0; i < fi.length; i++) {
                                                    draft.foreignInvoices.push(fi[i]);
                                                }
                                            })
                                        }}
                                            foreignCompanyId={formModel.debForeignId} />
                                    </TeamleaderLink>
                                </Grid></> : <></>}
                            {formModel.debAppId == ConnectedApp.Octopus ? <>
                                <Grid item xs={4}>
                                    <OctopusLink>
                                        <SearchInvoicesViaOctopus onSelectInvoices={(invoices) => {
                                            setFormModel((draft) => {
                                                var fi = invoices.map((el) => { return { id: el.id, invoiceNumber: el.invoiceNumber, app: ConnectedApp.Octopus } });
                                                for (var i = 0; i < fi.length; i++) {
                                                    draft.foreignInvoices.push(fi[i]);
                                                }
                                            })
                                        }}
                                            foreignCompanyId={formModel.debForeignId} />
                                    </OctopusLink>
                                </Grid></> : <></>}

                            <Grid item xs={12}>
                                <div {...getRootProps()} style={{ borderRadius: "10px", padding: "26px", background: "#FDF4D6", border: "1px solid #EDBB5F" }}>
                                    <input {...getInputProps()} />
                                    {
                                        isDragActive ?
                                            <Typography style={{ color: "#AF750B" }} variant="body1">{t("createDossier.infoDebMessage2")}</Typography> :
                                            <Typography style={{ color: "#AF750B" }} variant="body1">{t("createDossier.infoDebMessage")}</Typography>
                                    }
                                </div>
                                {formModel.invoices.map((el, index) => {
                                    return <><p><FilePresent /><span style={{ position: "relative", bottom: "4px" }}>{" " + el.name}</span>
                                        <IconButton style={{ position: "relative", bottom: "6px" }} color="primary" onClick={() => { setFormModel((draft) => { draft.invoices.splice(index, 1) }) }}><Close /></IconButton></p></>
                                })}
                                {formModel.foreignInvoices.map((el, index) => {
                                    return <><p><img style={{ width: "24px" }} src={el.app == ConnectedApp.Teamleader ? TeamleaderLogo : OctopusLogo} /><span style={{ position: "relative", bottom: "4px" }}>{" " + el.invoiceNumber}</span>
                                        <IconButton style={{ position: "relative", bottom: "6px" }} color="primary" onClick={() => { setFormModel((draft) => { draft.foreignInvoices.splice(index, 1) }) }}><Close /></IconButton></p></>
                                })}
                            </Grid>
                            <Grid container spacing={2} justifyContent={"flex-end"}>
                                <Grid item >
                                    <LoadButton
                                        color={"grey"}
                                        style={{ width: "100%", marginTop: "14px" }}
                                        isLoading={false}
                                        type="submit"
                                        variant="contained"
                                        buttonText={t("createDossier.prev")}
                                        onClick={() => { setStep(1) }}>

                                    </LoadButton>
                                </Grid>
                                <Grid item >
                                    <LoadButton
                                        color={"primary"}
                                        style={{ width: "100%", marginTop: "14px" }}
                                        isLoading={false}
                                        type="submit"
                                        variant="contained"
                                        buttonText={t("createDossier.next")}
                                        onClick={() => { setStep(3) }}>

                                    </LoadButton>
                                </Grid>
                            </Grid>

                        </Grid>
                    </> : <></>}

                    {step == 3 ? <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="h2">{t("createDossier.step3Desc")}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <div {...getRootPropsAttachments()} style={{ borderRadius: "10px", padding: "26px", background: "#FDF4D6", border: "1px solid #EDBB5F" }}>
                                    <input {...getInputPropsAttachments()} />
                                    {
                                        isDragActiveAttachments ?
                                            <Typography style={{ color: "#AF750B" }} variant="body1">{t("createDossier.infoDebMessageAttachments2")}</Typography> :
                                            <Typography style={{ color: "#AF750B" }} variant="body1">{t("createDossier.infoDebMessageAttachments")}</Typography>
                                    }
                                </div>
                                {formModel.rappels.map((el, index) => {
                                    return <><p><FilePresent /><span style={{ position: "relative", bottom: "4px" }}> {"" + el.name}</span>
                                        <IconButton color="primary" onClick={() => { setFormModel((draft) => { draft.invoices.splice(index, 1) }) }}><Close /></IconButton></p></>
                                })}
                            </Grid>
                            <Grid container spacing={2} justifyContent={"flex-end"}>
                                <Grid item >
                                    <LoadButton
                                        color={"grey"}
                                        style={{ width: "100%", marginTop: "14px" }}
                                        isLoading={false}
                                        type="submit"
                                        variant="contained"
                                        buttonText={t("createDossier.prev")}
                                        onClick={() => { setStep(2) }}>

                                    </LoadButton>
                                </Grid>
                                <Grid item >
                                    <LoadButton
                                        color={"primary"}
                                        style={{ width: "100%", marginTop: "14px" }}
                                        isLoading={false}
                                        type="submit"
                                        variant="contained"
                                        buttonText={t("createDossier.next")}
                                        onClick={() => { formModel.betwist ? setStep(4) : setStep(5) }}>

                                    </LoadButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </> : <></>}

                    {step == 4 ? <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="h2">{t("createDossier.step4Desc")}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <div {...getRootPropsMessageAttchements()} style={{ borderRadius: "10px", padding: "26px", background: "#FDF4D6", border: "1px solid #EDBB5F" }}>
                                    <input {...getInputPropsMessageAttchements()} />
                                    {
                                        isDragMessageAttchements ?
                                            <Typography style={{ color: "#AF750B" }} variant="body1">{t("createDossier.infoDebMessageAttachments2")}</Typography> :
                                            <Typography style={{ color: "#AF750B" }} variant="body1">{t("createDossier.infoDebMessageAttachments")}</Typography>
                                    }
                                </div>
                                {formModel.files.map((el) => {
                                    return <><p><FilePresent /><span style={{ position: "relative", bottom: "4px" }}> {el.name}</span></p></>
                                })}

                            </Grid>
                            <Grid container spacing={2} justifyContent={"flex-end"}>

                                <Grid item >
                                    <LoadButton
                                        color={"grey"}
                                        style={{ width: "100%", marginTop: "14px" }}
                                        isLoading={false}
                                        type="submit"
                                        variant="contained"
                                        buttonText={t("createDossier.prev")}
                                        onClick={() => { setStep(3) }}>

                                    </LoadButton>
                                </Grid>
                                <Grid item >
                                    <LoadButton
                                        color={"primary"}
                                        style={{ width: "100%", marginTop: "14px" }}
                                        isLoading={false}
                                        type="submit"
                                        variant="contained"
                                        buttonText={t("createDossier.next")}
                                        onClick={() => { setStep(5) }}>

                                    </LoadButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </> : <></>}

                    {step == 5 ? <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="h2">{t("createDossier.step5Desc")}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h3">{t("createDossier.overviewDeb")}</Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <p>{formModel.name}</p>
                                <p>{formModel.debAddress} {formModel.debHouseNr}</p>
                                <p>{formModel.debPostalcode} {formModel.debCity}</p>
                                <p>{formModel.debEmail}</p>
                                <p>{t("createDossier.betwist")} : {formModel.betwist ? t("general.yes") : t("general.no")}</p>
                                <p>{t("general.totalValue")} : EUR {formModel.totalValue}</p>
                            </Grid>
                            <Grid item container xs={12} md={8}>
                                <Grid item xs={12}>
                                    <Typography variant="h3">{t("createDossier.step2")}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {formModel.invoices.map((el) => {
                                        return <><p><FilePresent /><span style={{ position: "relative", bottom: "4px" }}>{" " + el.name}</span></p></>
                                    })}
                                    {formModel.foreignInvoices.map((el) => {
                                        return <><p><img style={{ width: "24px" }} src={el.app == ConnectedApp.Teamleader ? TeamleaderLogo : OctopusLogo} /><span style={{ position: "relative", bottom: "4px" }}>{" " + el.invoiceNumber}</span></p></>
                                    })}
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h3">{t("createDossier.step3")}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {formModel.rappels.map((el) => {
                                        return <><p><FilePresent /><span style={{ position: "relative", bottom: "4px" }}>{" " + el.name}</span></p></>
                                    })}
                                </Grid>
                                {formModel.betwist ? <>
                                    <Grid item xs={12}>
                                        <Typography variant="h3">{t("createDossier.step4")}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {formModel.files.map((el) => {
                                            return <><p><FilePresent /><span style={{ position: "relative", bottom: "4px" }}>{" " + el.name}</span></p></>
                                        })}
                                    </Grid>
                                </> : <></>}


                            </Grid>
                            <Grid item xs={2}>

                                <Grid item >
                                    <LoadButton
                                        color={"grey"}
                                        style={{ width: "100%", marginTop: "14px" }}
                                        isLoading={false}
                                        type="submit"
                                        variant="contained"
                                        buttonText={t("createDossier.prev")}
                                        onClick={() => { setStep(4) }}>

                                    </LoadButton>
                                </Grid>

                            </Grid>

                            <Grid item xs={10}>
                                <LoadButton
                                    color={"primary"}
                                    style={{ width: "100%", marginTop: "14px" }}
                                    isLoading={saving}
                                    variant="contained"
                                    buttonText={t("createDossier.createDossierBtn")}
                                    onClick={createDossier}>

                                </LoadButton>
                            </Grid>

                        </Grid></> : <></>}

                </Grid>
                </>}

        </Grid>
    </>
}